import { render, staticRenderFns } from "./tablefooter.vue?vue&type=template&id=549cbff6"
import script from "./tablefooter.vue?vue&type=script&lang=js"
export * from "./tablefooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports